var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"reset",attrs:{"disabled":_vm.isDefaultVariant},on:{"click":function($event){$event.preventDefault();return _vm.resetSelectionToDefaults.apply(null, arguments)}}},[_c('fa-icon',{attrs:{"icon":['far', 'sync']}}),_vm._v(" Reset Selections ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }